module.exports = __webpack_public_path__ + "static/hybrid-meetings-will-bring-balance-to-the-workplace-5f03e167eaa9ffb0b72e53359d6ec388.png";